import React, { Component, Fragment } from 'react'
import ImageGallery from 'react-image-gallery';

class ImageGalleryViewer extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const galleryImages = this.props.images.map((image, index) => {
            return {
                original: image.src,
                thumbnail: image.src,
            }
        })

        const gallerySettings = {
            lazyLoad: true,
            showPlayButton: false,
            onErrorImageURL: 'https://via.placeholder.com/400x200/000',
            showFullscreenButton: false,
            slideDuration: 225,
            thumbnailPosition: 'bottom',
        }

        return (
            !this.props.images || this.props.images.length < 1 ? <Fragment /> :
            <Fragment>
                { galleryImages.length > 0 &&
                    <ImageGallery original={galleryImages[0].original} {...gallerySettings} items={galleryImages}></ImageGallery>
                }
        </Fragment>          
        )
    }
}

export default ImageGalleryViewer;